import { AnotherInput } from './anotherInput';
import { MUIButton } from './muiButton';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { toggleButtonGroupClasses } from '@mui/material/ToggleButtonGroup';
import { alpha, Components, Theme } from '@mui/material/styles';
import { brand, gray, red } from '../themePrimitives';

export const inputsCustomizations: Components<Theme> = {
  MuiButtonBase: {
    defaultProps: {
      disableTouchRipple: true,
      disableRipple: true
    },
    styleOverrides: {
      root: ({ theme }) => ({
        'boxSizing': 'border-box',
        'transition': 'all 100ms ease-in',
        '&:focus-visible': {
          outline: `3px solid ${alpha(theme.palette.primary.main, 0.5)}`,
          outlineOffset: '2px'
        }
      })
    }
  },
  MuiIconButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        'boxShadow': 'none',
        'borderRadius': theme.shape.borderRadius,
        'textTransform': 'none',
        'fontWeight': theme.typography.fontWeightMedium,
        'letterSpacing': 0,
        'color': theme.palette.text.primary,
        'border': 'none',
        'borderColor': 'transparent',
        'backgroundColor': 'transparent',
        '&:hover': {
          backgroundColor: 'transparent',
          borderColor: 'transparent'
        },
        '&:active': {
          backgroundColor: 'transparent'
        },
        ...theme.applyStyles('dark', {
          'backgroundColor': 'transparent',
          'borderColor': 'none',
          '&:hover': {
            backgroundColor: 'transparent',
            borderColor: gray[600]
          }
        }),
        'variants': [
          {
            props: {
              size: 'small'
            },
            style: {
              width: '2.25rem',
              height: '2.25rem',
              padding: '0.25rem',
              [`& .${svgIconClasses.root}`]: { fontSize: '1rem' }
            }
          },
          {
            props: {
              color: 'primary'
            },
            style: {
              width: '2.25rem',
              height: '2.25rem',
              padding: '0.25rem',
              color: brand[300]
            }
          },
          {
            props: {
              color: 'error'
            },
            style: {
              width: '2.25rem',
              height: '2.25rem',
              padding: '0.25rem',
              color: red[300]
            }
          },
          {
            props: {
              size: 'medium'
            },
            style: {
              width: '2.5rem',
              height: '2.5rem'
            }
          }
        ]
        // ...(theme.palette && {
        //   '&.MuiIconButton-colorPrimary': {
        //     'color': theme.palette.primary.main,
        //     'backgroundColor': theme.palette.primary.light,
        //     '&:hover': {
        //       backgroundColor: theme.palette.primary.dark
        //     },
        //     '&:active': {
        //       backgroundColor: theme.palette.primary.dark
        //     }
        //   },
        //   '&.MuiIconButton-colorError': {
        //     'color': theme.palette.error.main,
        //     'backgroundColor': theme.palette.error.light,
        //     '&:hover': {
        //       backgroundColor: theme.palette.error.dark
        //     },
        //     '&:active': {
        //       backgroundColor: theme.palette.error.dark
        //     }
        //   },
        //   '&.MuiIconButton-colorSecondary': {
        //     'color': theme.palette.secondary.main,
        //     'backgroundColor': theme.palette.secondary.light,
        //     '&:hover': {
        //       backgroundColor: theme.palette.secondary.dark
        //     },
        //     '&:active': {
        //       backgroundColor: theme.palette.secondary.dark
        //     }
        //   }
        // })
      })
    }
  },
  MuiToggleButtonGroup: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: '10px',
        [`& .${toggleButtonGroupClasses.selected}`]: {
          color: brand[500]
        },
        ...theme.applyStyles('dark', {
          [`& .${toggleButtonGroupClasses.selected}`]: {
            color: '#fff'
          },
          boxShadow: `0 4px 16px ${alpha(brand[700], 0.5)}`
        })
      })
    }
  },
  ...AnotherInput,
  ...MUIButton
};
